define('GameModel/GameModel',['require','exports','module','MasterScoreboard/MasterScoreboard','ticketingService/ticketingService','events/paperboy','floorDate/floorDate','flipDate/flipDate','ensureArray/ensureArray','jquery'],function(require,exports,module){

    //var GameService = require('gameService/gameService');

    var MasterScoreboard = require('MasterScoreboard/MasterScoreboard');
    var TicketService = require('ticketingService/ticketingService');

    var events      = require('events/paperboy');
    var floorDate   = require("floorDate/floorDate");
    var flipDate    = require('flipDate/flipDate');
    var ensureArray = require('ensureArray/ensureArray');
    var $           = require('jquery');
    var extend      = $.extend;

    function normalizeDate(date) {
        // If undefined, set date current date/time Eastern and display
        // previous day's scoreboard until 11am ET (or specified time)
        // Floor value of date to 00:00:00.000 for simpler comparison later on
        return floorDate('day', typeof date === 'undefined' ? flipDate.today() : date);
    }


    function removeExhibitionGames( games, opt ){

        //if true remove exhibition games otherwise return all games
        if( opt.removeExhibitionGames ){

            return games.filter(function( game ){

                if(game.game_type != "E"){

                    return game;
                }
            });

        }else{

            return games;
        }

    }


    function GameModel(config) {

        //options
        var opt = this.options = extend(true,{

            isQA                  : false,
            enableGdxDomain		  : false,
            removeExhibitionGames : true,
            date                  : undefined,
            enableTicketing       : false,
            enableLookin          : false

        }, config);

        //event list
        this.events = ['refresh','loadSuccess', 'loadError', 'empty'];

        //event trigger
        this.trigger = events.mixin( this, this.events );

        this.msb = new this.MasterScoreboard();

    }

    GameModel.prototype = {
        //Masterscoreboard class exposed for overriding.
        MasterScoreboard : MasterScoreboard,

        init : function(){

            var self = this;

            if(self.options.enableTicketing) {

                self.initTickets();
            }

            //self.initGameService();

            self.initMasterScoreboard();

        },

        //initialize game service
        initGameService : function(){

            var self = this;
            var opt = this.options;
            var gameService = this.gameService = GameService;
            var trigger = this.trigger;
            var date = normalizeDate( opt.date );

            //if this.options.isQA true get QA data
            var isQA = this.options.isQA;
            gameService.setQA(isQA);

            this.games = [];


            gameService.loadDay( date ).done(function( day ) {

                day.on('update', function( dayGames ){

                    self.games = removeExhibitionGames( ensureArray( dayGames.games ), opt );

                    self.extendGames( self.games );
					if (self.games && self.games.length) {
                    	trigger('refresh',  self.games );
                    } else {
	                    trigger('empty');
                    	trigger('refresh',  self.games ); //maintaining backwards compatibility
                    }

                });

                self.games = removeExhibitionGames( ensureArray( day.games ), opt );

                self.extendGames( self.games );
				if (self.games && self.games.length) {
                	trigger('loadSuccess', self.games );
                } else {
	                trigger('empty');
	                trigger('loadSuccess', self.games ); //maintaining backwards compatibility

                }

            });

        },

        initMasterScoreboard : function(){


            var self = this;
            var opt  = this.options;
            var date = normalizeDate( opt.date );
            var msb  = this.msb;
            var trigger = this.trigger;

            msb.on('success', function( data ){

                data.games = removeExhibitionGames( ensureArray( data.games ), opt );
                self.extendGames( data.games );

				if (data.games && data.games.length) {
					trigger('loadSuccess', data );
				} else {
					trigger('empty');
					trigger('loadSuccess', data ); //maintaining backwards compatibility
				}

            });
            
            msb.on('error', function() {
	          	trigger('loadError');  
            });

            msb.load(date, opt);
            msb.start();

        },

        load  : function( date ){
            var msb = this.msb;
            this.options.date = date;
            msb.stop();
            msb.load(date, this.options);
            msb.start();
			
            if(this.options.enableTicketing) {
				this.initTickets();
			}
        },

        initTickets : function(){

            var self          = this;
            var date          = this.options.date;
            var ticketService = this.ticketService = new TicketService({date:date});
            var deferred      = $.Deferred();

            ticketService.start();

            ticketService.on('loadSuccess', function( tix ) {

                if(tix && tix.length){

                    if(self.options.extender){

                        self.options.extender.setTicketCache( tix );

                        if(self.games && self.games.length){

                            self.extendGames(self.games);

                            self.trigger('refresh', self.games);
                        }

                    }

                }else{

                    ticketService.stop();

                }

            });

            ticketService.load();
        },

        setLookInData : function( data ){


            if(this.options.extender){

                this.options.extender.setLookin( data );

            }

        },

        clearLookInData : function(){

            if(this.options.extender){

                this.options.extender.clearLookin();

            }

        },

        //augment games with custom display data
        extendGames : function( games ){

            if( this.options.extender ){

                var extender = this.options.extender;

                games.forEach( function( game ){

                    extender.extendGame( game );
                });

            }

        },

        destroy : function(){

            this.msb.destroy();

            if(this.ticketService){
                this.ticketService.stop();
                this.ticketService = null;
            }
        }
    };

    //Model factory function
    //Wrapped in deferreds to avoid race condition
    GameModel.createModel = function( opt ){

        var defer = $.Deferred(),
            // GameModel constructor
            Model = this;

        $.when( new Model( opt ) ).done( function( model ){

            defer.resolve( model );

        });

        return defer.promise();

    };

    module.exports=GameModel;

});
